import { BoxProps, HStack } from '@chakra-ui/react';
import { compact } from 'lodash';
import { useSelector } from 'react-redux';
import { SOCIAL_PLATFORMS } from '~/constants';
import { selectCreator } from '~/selectors/creator';
import { YoutubeChannelType } from '~/types';
import { getPlatformUrl } from '~/utils-ts';

import { Platform } from './components/PlatformFollowersLabel';
import { PlatformFollowersLabel } from './components/PlatformFollowersLabel/PlatformFollowersLabel';

interface Props extends BoxProps {
  platforms: Platform[];
  ytChannel: YoutubeChannelType;
}

export const Platforms: React.FC<Props> = ({
  platforms,
  ytChannel,
  ...props
}) => {
  const creator = useSelector(selectCreator);
  const tiktok = platforms.find(
    (platform) => platform.name === SOCIAL_PLATFORMS.tiktok,
  );
  const youtube = platforms.find(
    (platform) => platform.name === SOCIAL_PLATFORMS.youtube,
  );
  const instagram = platforms.find(
    (platform) => platform.name === SOCIAL_PLATFORMS.instagram,
  );
  const sortedPlatforms = compact([instagram, tiktok, youtube]);

  return (
    <HStack {...props} spacing={8}>
      {sortedPlatforms.map((platform) => (
        <PlatformFollowersLabel
          key={`platform-followers-label-${platform.name}`}
          platform={platform ?? ({} as Platform)}
          href={getPlatformUrl(platform.name, creator as any, ytChannel)}
        />
      ))}
    </HStack>
  );
};
